import {
  is24GWorkMode,
  resolveEquipmentWorkMode,
} from "../musicRhythm/hfdWirelessMusicRhythm";

const TFT_KEYBOARD_TYPES = new Set(["x75gc", "75ProTFT", "M98TFT", "M98 8K"]);

export type HfdTftScreenEquipmentLike = {
  solutionRovider?: string;
  keyboardType?: string;
  displayname?: string;
  productName?: string;
  hasScreen?: boolean;
  workMode?: string | number;
};

/** 华奋达带 TFT 屏幕的键盘（有线 / 2.4G 均算） */
export function isHfdTftScreenDevice(
  eq: HfdTftScreenEquipmentLike | Record<string, unknown> | null | undefined
): boolean {
  if (!eq || typeof eq !== "object") return false;
  const provider = String(eq.solutionRovider ?? "")
    .trim()
    .toLowerCase();
  if (provider && provider !== "huafenda") return false;
  if (eq.hasScreen === true) return true;

  const kt = String(eq.keyboardType ?? "").trim();
  if (TFT_KEYBOARD_TYPES.has(kt)) return true;

  const nameBlob = `${eq.displayname ?? ""} ${eq.productName ?? ""}`;
  return /x75\s*gc|x75\s*pro\s*screen|m98\s*screen|m98\s*\(8k\)/i.test(
    nameBlob
  );
}

/** TFT 屏幕功能在 2.4G 下不可用（菜单置灰 / 页面遮罩） */
export function isHfdTftScreenWirelessBlocked(
  eq: HfdTftScreenEquipmentLike | Record<string, unknown> | null | undefined
): boolean {
  if (!isHfdTftScreenDevice(eq)) return false;
  return is24GWorkMode(resolveEquipmentWorkMode(eq));
}
